import type { ChipColor } from "@app/components/pod/cahier/format";
import type { NatureEtat } from "@app/types/compta/etats";
import { assertNever } from "@app/types/shared/utils/assert_never";

// La couleur de `reviewBadge` (l'en-tête du cahier) devient la nature d'état
// de la coquille (le point coloré du portefeuille).
//
// Deux vocabulaires pour UN jugement, et c'est tout l'intérêt : le portefeuille
// ne redérive rien, il traduit ce que le cahier a déjà dit avec les trois
// règles que la relecture métier a rendues non négociables (`format.ts`).
//
// `assertNever` [GEN6] : la couleur est produite par NOTRE code, pas reçue
// d'un serveur. Une couleur ajoutée à `reviewBadge` sans ligne ici est une
// faute de programmation, pas une valeur inconnue à tolérer.

export function natureDuBadge(couleur: ChipColor): NatureEtat {
  switch (couleur) {
    // Réservé par `reviewBadge` à « plus rien à dire au client » : le seul vert.
    case "success":
      return "favorable";
    // « Premier passage non revu » ou « revu, N points retenus » : quelque
    // chose reste à dire, rien n'empêche d'avancer.
    case "warning":
      return "attente";
    // « Cycles terminés revus, mission en échec » : il manque des chiffres.
    case "highlight":
      return "bloquant";
    case "info":
    case "primary":
      return "neutre";
    default:
      return assertNever(couleur);
  }
}
